<template>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <label class="label">{{client.username}}</label>
          <div class="table-responsive">
            <table class="table is-bordered is-striped is-narrow">
              <thead>
              <tr>
                <th @click="sort('date')">Дата{{sortIcon('date')}}</th>
                <th @click="sort('sumPay')">Сумма пополнено{{sortIcon('sumPay')}}</th>
                <th @click="sort('sumConsume')">Сумма израсходовано{{sortIcon('sumConsume')}}</th>
                <th @click="sort('author')">Автор{{sortIcon('author')}}</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="billing in sortedBillings">
                <td>
                  {{billing.date}}
                </td>
                <td>
                  {{billing.sumPay}}
                </td>
                <td>
                  {{billing.sumConsume}}
                </td>
                <td>
                  {{billing.author}}
                </td>
                <td>
                </td>
              </tr>
              <tr v-if="canCreate(permissionKey)">
                <td>
                  <!--<input v-model="newbilling.date" class="input" type="date" placeholder="Введите дату">-->
                  <datepicker v-model="newbilling.date" placeholder="Введите дату" :inputClass="{ test: true }" :config="{ wrap: true, dateFormat: 'd.m.Y', locale: l10n }" readonly>
                    <a class="button" data-toggle><i class="fa fa-calendar"></i></a>
                    <a class="button" data-clear><i class="fa fa-close"></i></a>
                  </datepicker>
                </td>
                <td><input v-model="newbilling.sumPay" class="input" type="" placeholder="Введите сумму оплаты"></td>
                <td></td>
                <td>
                <td>
                  <button class="button is-success" v-on:click="addPayment">
                    <span class="icon">
                      <i class="fa fa-plus-circle"></i>
                    </span>
                    <span>Добавить оплату</span>
                  </button>
                </td>
              </tr>
              <tr>
                <th>ИТОГО</th>
                <th>{{sumPay}}</th>
                <th>{{sumConsume}}</th>
                <th>ОСТАТОК</th>
                <th>{{balance}}</th>
              </tr>
              </tbody>
            </table>
          </div>
          <div id="page-navigation">
            <ul class="pagination">
              <li class="pagination-item">
                <button
                  type="button"
                  @click="onClickFirstPage"
                  :disabled="isInFirstPage"
                  aria-label="Go to first page"
                >
                  Первая
                </button>
              </li>
              <li class="pagination-item">
                <button
                  type="button"
                  @click="onClickPreviousPage"
                  :disabled="isInFirstPage"
                  aria-label="Go to previous page"
                >
                  Предыдущая
                </button>
              </li>
              <li v-for="page in pages" class="pagination-item">
                <button
                  type="button"
                  @click="onClickPage(page.name)"
                  :disabled="page.isDisabled"
                  :class="{ activepage: isPageActive(page.name) }"
                  :aria-label="`Go to page number ${page.name}`"
                >
                  {{ page.name }}
                </button>
              </li>
              <li class="pagination-item">
                <button
                  type="button"
                  @click="onClickNextPage"
                  :disabled="isInLastPage"
                  aria-label="Go to next page"
                >
                  Следующая
                </button>
              </li>
              <li class="pagination-item">
                <button
                  type="button"
                  @click="onClickLastPage"
                  :disabled="isInLastPage"
                  aria-label="Go to last page"
                >
                  Последняя
                </button>
              </li>
            </ul>
          </div>
          <br>
          <div v-if="loggedId==$props.id" class="control is-grouped">
            <p class="control">
              <button class="button is-primary" v-on:click="makePayment">
                <span class="icon">
                  <i class="fa fa-money"></i>
                </span>
                <span>Оплатить на сумму</span>
              </button>
            </p>
            <p class="control is-expanded">
              <input v-model="sumPayment" class="input" type="" placeholder="Введите сумму оплаты">
            </p>
          </div>
            <p class="control">
              <button class="button is-primary" v-on:click="cancel">
                <span class="icon">
                  <i class="fa fa-times-circle"></i>
                </span>
                <span>Закрыть</span>
              </button>
            </p>
        </article>
      </div>
    </div>
</template>

<script>
import Datepicker from 'vue-bulma-datepicker'
import Cleave from 'vue-cleave'
import { mapGetters } from 'vuex'
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
import CheckToken from '../authentication/CheckToken'
import CheckPermission from '../authentication/CheckPermission'

Vue.mixin(CheckToken)
Vue.mixin(CheckPermission)

const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}

const BILLING_API = '/api/billing'
const USERS_API = '/api/users'
const PAYMENTS_API = '/api/payments'

export default {
  props: ['id'],
  components: {
    Datepicker,
    Cleave,
    Notification
  },
  computed: {
    ...mapGetters([
      'loggedId',
      'authenticationToken'
    ]),
    l10n () {
      return {
        firstDayOfWeek: 1,
        weekdays: {
          shorthand: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
          longhand: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье']
        },
        months: {
          shorthand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
          longhand: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
        }
      }
    },
    totalPages() {
      return Math.max(Math.ceil(this.billings.length / this.perPage), 1)
    },
    startPage() {
      if (this.currentPage === 1) {
        return 1
      }

      if (this.currentPage === this.totalPages) {
        return Math.max(this.totalPages - this.maxVisibleButtons + 1, 1)
      }

      return this.currentPage - 1
    },
    endPage() {
      return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages)
    },
    pages() {
      const range = []
      for (let i = this.startPage; i <= this.endPage; i += 1) {
        range.push({
          name: i,
          isDisabled: i === this.currentPage
        })
      }
      return range
    },
    isInFirstPage() {
      return this.currentPage === 1
    },
    isInLastPage() {
      return this.currentPage === this.totalPages
    }
  },
  methods: {
    prepareSecurityHeader() {
      console.log(this.authenticationToken)
      return {
        Authorization: `Bearer ${this.authenticationToken}`,
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, DELETE, GET, POST, OPTIONS',
        'Access-Control-Allow-Headers': 'DNT,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Range',
        'Access-Control-Expose-Headers': 'Content-Length,Content-Range'
      }
    },
    loadBilling () {
      this.$http({
        url: BILLING_API + '/' + this.$props.id,
        headers: this.prepareSecurityHeader()
      }).then((response) => {
        console.log('opening campaign ' + response.data.id)
        this.billings = response.data
        this.sortedBillings = this.sortedBilling()
      }).catch((error) => {
        console.log(error)
        this.openNotificationWithType('danger', 'Ошибка загрузки информации об оплате. ')
      })
    },
    loadClient () {
      this.$http.get(USERS_API + '/' + this.$props.id, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.client = response.data
        })
    },
    cancel () {
//      this.$router.push('/users/' + this.$props.id)
      this.$router.push('/users/')
    },
    addPayment () {
      if (this.newbilling.date) {
        if (this.reg.test(this.newbilling.sumPay)) {
          if (this.newbilling.sumPay != 0) {
            this.newbilling.client = this.client.id
            this.newbilling.sumConsume = 0
            this.$http.post(BILLING_API, this.newbilling, {headers: this.prepareSecurityHeader()})
              .then((response) => {
                this.openNotificationWithType('success', 'Оплата добавлена')
                this.billings = response.data
                this.sortedBillings = this.sortedBilling()
                this.getBalance()
                this.getSumPayment()
                this.getSumConsume()
                this.newbilling.date = ''
                this.newbilling.sumPay = ''
              })
              .catch((error) => {
                console.log(error)
                this.openNotificationWithType('danger', 'Ошибка добавления оплаты. ')
              })
          } else {
            this.openNotificationWithType('danger', 'Укажите ненулевую сумму')
          }
        } else {
          this.openNotificationWithType('danger', 'Некорректный формат числа')
        }
      } else {
        this.openNotificationWithType('danger', 'Необходимо выбрать дату')
      }
    },
    getBalance() {
      this.$http.get(BILLING_API + '/balance/' + this.$props.id, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.balance = response.data
        })
    },
    getSumPayment() {
      this.$http.get(BILLING_API + '/sumpayment/' + this.$props.id, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.sumPay = response.data
        })
    },
    getSumConsume() {
      this.$http.get(BILLING_API + '/sumconsume/' + this.$props.id, {headers: this.prepareSecurityHeader()})
        .then((response) => {
          this.sumConsume = response.data
        })
    },
    makePayment() {
      if (this.reg.test(this.sumPayment)) {
        if (this.sumPayment > 0) {
          this.$http.post(PAYMENTS_API + '/yandex', this.preparePaymentParameters(this.loggedId, this.sumPayment),
            {headers: this.prepareSecurityHeader()})
            .then((response) => {
              console.log(response)
              console.log(response.data)
              window.location.href = response.data
            })
            .catch((error) => {
              console.log(error)
              this.openNotificationWithType('danger', 'Ошибка платежа. ')
            })
        } else {
          this.openNotificationWithType('danger', 'Укажите сумму больше нуля')
        }
      } else {
        this.openNotificationWithType('danger', 'Некорректный формат числа')
      }
    },
    preparePaymentParameters (id, sum) {
      const paymentFormData = new FormData()
      const currentUrl = window.location
      paymentFormData.append('id', id)
      paymentFormData.append('sum', sum)
      paymentFormData.append('returnUrl', currentUrl)
      return paymentFormData
    },
    sortedBilling() {
      return this.billings.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      }).filter((row, index) => {
        let start = (this.currentPage - 1) * this.perPage
        let end = this.currentPage * this.perPage
        if (index >= start && index < end) return true
      })
    },
    sort(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
      this.sortedBillings = this.sortedBilling()
    },
    sortIcon(s) {
      if (s === this.currentSort) {
        if (this.currentSortDir === 'asc') {
          return this.ascIcon
        } else {
          return this.descIcon
        }
      } else {
        return ''
      }
    },
    onClickFirstPage() {
      this.onPageChange(1)
    },
    onClickPreviousPage() {
      this.onPageChange(this.currentPage - 1)
    },
    onClickPage(page) {
      this.onPageChange(page)
    },
    onClickNextPage() {
      this.onPageChange(this.currentPage + 1)
    },
    onClickLastPage() {
      this.onPageChange(this.totalPages)
    },
    isPageActive(page) {
      return this.currentPage === page
    },
    onPageChange(page) {
      this.currentPage = page
      this.sortedBillings = this.sortedBilling()
    },
    viewBilling (id) {
      this.$router.push('/billing/client/' + id)
    },
    viewProfile (id) {
      this.$router.push('/profiles/' + id)
    },
    openNotificationWithType (type, message) {
      openNotification({
        title: 'Уведомление',
        message: message,
        type: type
      })
    }
  },
  data () {
    return {
      billings: [],
      sortedBillings: [],
      currentPage: 1,
      perPage: 10,
      maxVisibleButtons: 10,
      currentSort: 'date',
      currentSortDir: 'asc',
      ascIcon: ' ▲',
      descIcon: ' ▼',
      newbilling: {},
      client: '',
      balance: 0,
      sumPay: 0,
      sumConsume: 0,
      sumPayment: 0,
      permissionKey: 'billing',
      reg: /^[-]?[0-9]+[.]?[0-9]{0,2}$/
    }
  },
  created: function () {
    if (!this.$props.id) {
      this.$router.push('/users')
    } else {
      console.log('loading billing: ' + this.name)
      this.loadBilling()
      this.loadClient()
      this.getBalance()
      this.getSumPayment()
      this.getSumConsume()
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';

.time {
  margin: 0px 10px;
}

.pagination {
  list-style-type: none;
}

.pagination-item {
  display: inline-block;
}

.activepage {
  background-color: #4AAE9B;
  color: #ffffff;
}


</style>



// WEBPACK FOOTER //
// Billing.vue?b7690cc6